import React from 'react';
import { CardTitle, Col, Row, Spinner } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { apiFindSMPromotionsError, allSMPromotionsPaginate } from "../../../../store/actions";
import PropTypes from "prop-types";
import ImageURI from 'components/ImageURI';

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}

        this._showingpaginate = this._showingpaginate.bind(this);
        this.handleClickPagination = this.handleClickPagination.bind(this);
        this._showingstatuslabel = this._showingstatuslabel.bind(this);
    }

    componentDidMount() {
        this._all_by_paginate(1, 10)
    }

    _showingstatuslabel(value) {
        switch (parseInt(value)) {
            case 0:
                return (<span className="badge pill bg-danger p-1" style={{ fontSize: '90%' }}>Inativo</span>);
            case 1:
                return (<span className="badge pill bg-success p-1" style={{ fontSize: '90%' }}> Ativo </span>);
            default:
                return (<span className="badge pill bg-success p-1" style={{ fontSize: '90%' }}> Ativo </span>);
        }

    }

    async handleClickPagination(value) {
        await this._all_by_paginate(value, 10)
    }

    async _all_by_paginate(page, limit) {

        this.props.allSMPromotionsPaginate({
            company_id: 1, page, limit
        })
    }

    _showingpaginate(current_page, last_page, total, from, to) {
        let pages = [];

        if (to <= total) {

            for (let i = 1; i <= last_page; i++) {

                pages.push(i)

            }

        }
        if (current_page <= last_page) {
            return (
                <div className="clearfix">
                    <ul className="pagination pagination-sm m-0 float-right">
                        <li className="page-item" key={11 + 'ss'}>
                            <button disabled={1 === current_page}
                                className={`page-link ${1 === current_page ? 'text-light bg-dark' : ''}`}
                                onClick={() => this.handleClickPagination(1)}>Primeiro
                            </button>
                        </li>
                        {
                            pages.map((page, index) => {
                                return (<li key={index} className="page-item">
                                    <button disabled={page === current_page}
                                        className={`page-link ${page === current_page ? 'text-light bg-dark' : ''}`}
                                        onClick={() => this.handleClickPagination(page)}>{page}</button>
                                </li>)
                            })
                        }
                        <li key={12 + 'ss'} className="page-item ">
                            <button disabled={last_page === current_page}
                                className={`page-link ${last_page === current_page ? 'text-light bg-dark' : ''}`}
                                onClick={() => this.handleClickPagination(last_page)}>Último
                            </button>
                        </li>
                    </ul>
                </div>
            )
        }
    }

    render() {
        const { columns, edit, route_edit, refresh, showStatus } = this.props;
        if (this.props.refresh) {
            this._all_by_paginate(1, 10)
        }

        return (
            <div>
                <CardTitle>Listagem feed de promoções</CardTitle>
                {
                    this.props.loading
                        ?
                        <div className="text-center" style={{ width: '100%', position: 'absolute', paddingBottom: 20 }}>
                            <Spinner size="sm" animation="border"
                                style={{ marginBottom: 20 }}
                                variant="success" />
                        </div>
                        :
                        <>
                            <Row className="align-items-md-center  mb-3">
                                <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline">
                                        <span className="text-muted">

                                        </span>
                                    </div>
                                    <div className="text-md-right ms-auto">
                                        <a
                                            onClick={() => this.props.getFormRegister(1)}
                                            className="btn btn-dark btn-sm text-light"
                                        >
                                            <i className="bx bx-plus-circle" />
                                            <span> Novo Cadastro</span>
                                        </a>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    <table className="table table-bordered table-striped table-responsive">
                                        <thead>
                                            <tr>
                                                {columns.map(
                                                    (column, index) => {
                                                        return (
                                                            <th key={index} className="text-center">{column.name}</th>
                                                        )
                                                    })
                                                }

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {

                                                this.props.rows &&
                                                    this.props.rows.length > 0
                                                    ?
                                                    this.props.rows.map((row, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td className="text-center" >
                                                                    <ImageURI url={row.url_image} alt={row.product.name} />
                                                                </td>
                                                                <td  >
                                                                    <p>{row.product.name}</p>
                                                                    <p>{row.description}</p>
                                                                    <p>{row.tags}</p>
                                                                </td>

                                                                <td className="text-center">
                                                                    <div className="btn-group">

                                                                        {edit !== false &&
                                                                            <a className="btn btn-dark btn-sm"
                                                                                onClick={() => {
                                                                                    this.props.findEntityEdit(row.id)
                                                                                }}>
                                                                                <i className="fas fa-edit"></i>
                                                                            </a>
                                                                        }


                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        {columns.map(item => <td></td>)}
                                                    </tr>
                                            }


                                        </tbody>
                                    </table>
                                </Col>

                            </Row>
                            <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline">
                                        <span className="mt-1 text-muted">
                                            {this.props.from} de {this.props.total} - página {this.props.current_page} de {this.props.last_page}
                                        </span>
                                    </div>
                                    <div className="text-md-right ms-auto">
                                        {this._showingpaginate(
                                            this.props.current_page, this.props.last_page, this.props.total,
                                            this.props.from, this.props.to)}
                                    </div>
                                </Col>
                            </Row>
                        </>
                }
            </div>


        )
    }


}

Index.propTypes = {
    apiFindSMPromotionsError: PropTypes.any,
    error: PropTypes.any,
    loading: PropTypes.any,
    refresh: PropTypes.any,
    loading_delete: PropTypes.any,
    rows: PropTypes.any,
    current_page: PropTypes.number,
    last_page: PropTypes.number,
    total: PropTypes.number,
    from: PropTypes.number,
    to: PropTypes.number,
    allSMPromotionsPaginate: PropTypes.func,
    getFormRegister: PropTypes.func,
    findEntityEdit: PropTypes.func,

}

const mapStateToProps = state => {
    const {
        loading,
        refresh,
        rows,
        current_page,
        last_page,
        total,
        from,
        to,
        loading_delete
    } = state.SMPromotions
    return {
        loading,
        refresh,
        rows,
        current_page,
        last_page,
        total,
        from,
        to,
        loading_delete
    }
}

export default withRouter(
    connect(mapStateToProps, {
        allSMPromotionsPaginate,
        apiFindSMPromotionsError,

    })(Index)
)

